import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import { useNavigate, useParams } from 'react-router-dom'
import mentorsService from '@/services/mentorsService'
import { useEffect } from 'react'
import Spinner from '@/components/atoms/Spinner'
import { CardSession } from '@/components/molecules/Admin/Cards/CardSession'
import { useAppSelector } from '@/store/hooks'

export function Hero() {
	const { slug: mentorSlug } = useParams()
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const navigate = useNavigate()

	const {
		data: dataMentor,
		isLoading,
		isError,
	} = mentorsService.getMentor({
		mentorSlug: mentorSlug || '',
	})

	useEffect(() => {
		if (isError) navigate('/mentores')
	})

	const mentorVertical = dataMentor?.verticals[0]?.title || ''
	const mentorIsEmpreenda =
		dataMentor?.tag && ['EMPREENDA']?.includes(dataMentor?.tag?.toUpperCase())

	return (
		<Container className='bg-transparent py-10'>
			<div className='flex flex-col gap-11'>
				<div className='flex flex-col items-start'>
					<button
						onClick={() => navigate('/mentorias')}
						className='flex items-center justify-center font-bold text-base leading-[18px] text-white gap-2'
					>
						<Icon
							name='arrow-left'
							width='27'
							height='14'
							className='fill-white'
						/>
						<div>Voltar para todos os mentores</div>
					</button>
				</div>

				{(() => {
					if (isLoading) {
						return (
							<div className='flex justify-center'>
								<Spinner
									className={
										'inline w-10 h-10 text-gray-200 animate-spin fill-brand-primary'
									}
								/>
							</div>
						)
					}

					return (
						<>
							<div className='flex flex-col gap-10 md:gap-8'>
								<div className='bg-transparent rounded-2xl max-w-[808px]'>
									<div className='flex flex-col gap-8'>
										<div className='flex relative max-w-max'>
											{(() => {
												if (dataMentor?.profilePicture) {
													return (
														<img
															src={`${process.env.REACT_APP_IMAGE_PROFILE_URL}${dataMentor?.profilePicture}`}
															alt='Avatar User'
															className='min-w-[108px] min-h-[108px] max-w-[108px] max-h-[108px] object-fill rounded-full'
														/>
													)
												}

												return (
													<Icon
														name='default-avatar'
														width='108'
														height='108'
														className='min-w-[108px] min-h-[108px] max-w-[108px] max-h-[108px] object-fill rounded-full'
													/>
												)
											})()}

											{(() => {
												if (dataMentor?.companyPicture) {
													return (
														<img
															src={`${process.env.REACT_APP_IMAGE_PROFILE_URL}${dataMentor?.companyPicture}`}
															alt='Avatar Company Mentor'
															className='min-w-[44px] min-h-[44px] max-w-[44px] max-h-[44px] absolute -bottom-2 -right-3 border-2 object-fill border-gray-50 rounded-full'
														/>
													)
												}

												return (
													<Icon
														name='default-avatar'
														width='44'
														height='44'
														className='min-w-[44px] min-h-[44px] max-w-[44px] max-h-[44px] absolute -bottom-2 -right-3 border-2 object-fill border-gray-50 rounded-full'
													/>
												)
											})()}
										</div>
										<div className='flex flex-col gap-6'>
											<div className='flex flex-col gap-1'>
												<p className='text-3xl leading-[120%] font-medium text-zinc-50'>
													{`${dataMentor?.name} ${dataMentor?.lastName}`}
												</p>
												<div className='flex flex-col gap-4'>
													{(() => {
														if (
															dataMentor?.companyName ||
															dataMentor?.companyRole
														) {
															return (
																<p className='text-sm leading-[120%] text-white/50 font-medium'>
																	{dataMentor?.companyRole}
																	{dataMentor?.companyRole &&
																		dataMentor?.companyName &&
																		', '}
																	{dataMentor?.companyName}
																</p>
															)
														}
														return (
															<p className='text-white/50'>
																Mentor(a), Fluency
															</p>
														)
													})()}
												</div>
											</div>
										</div>
										<div className='flex flex-col gap-4'>
											{(() => {
												if (dataMentor?.bio)
													return (
														<p className='text-base leading-[155%] text-white/70 font-medium'>
															{dataMentor?.bio}
														</p>
													)

												return (
													<p className='text-base leading-[155%] text-white/70 font-medium'>
														Você ainda não editou sua biografia
													</p>
												)
											})()}
										</div>

										{dataMentor &&
											dataMentor?.tags &&
											dataMentor?.tags?.length > 0 && (
												<div className='flex flex-col gap-4'>
													<span className='text-lg leading-[120%] font-medium text-zinc-50'>
														Especialidades
													</span>
													<div className='flex gap-2 flex-wrap'>
														{dataMentor?.tags?.map((tag, key) => (
															<p
																key={key}
																className='text-sm leading-4 text-white/70 font-medium bg-gray-100 dark:text-[#1C2530] rounded-full py-[5px] px-3'
															>
																{tag.name}
															</p>
														))}
													</div>
												</div>
											)}
									</div>
								</div>
							</div>

							<div className='flex flex-col gap-10'>
								<div className='flex flex-col gap-2'>
									<h2 className='text-2xl text-white font-medium'>
										Agendar Mentoria
									</h2>
									<h3 className='text-base text-white/70 font-medium'>
										É só clicar no botão abaixo para escolher um horário e
										agendar sua mentoria individual com{' '}
										{dataMentor?.name || 'mentor(a)'}:
									</h3>
								</div>
								{(() => {
									if (mentorIsEmpreenda) {
										return (
											<div className='grid grid-cols-1 gap-4 md:grid-cols-[315px_minmax(315px,_1fr)] max-w-[750px] justify-start'>
												{!!dataMentor.dualProfile &&
													!['EMPREENDA']?.includes(
														user?.tag?.toUpperCase() || ''
													) && (
														<CardSession
															infoSession={{
																title: `Mentoria de ${mentorVertical}`,
																duration: 30,
																subtitle: `Conversa de 30 minutos sobre temas
																	relacionados a ${mentorVertical.toLowerCase()}.`,
																dataMentor,
																vertical: mentorVertical,
																isMentorshipAwari: true,
																tag: dataMentor.tag,
															}}
														/>
													)}

												<CardSession
													infoSession={{
														title: `Devolutiva Inicial - Mapeamento de Habilidades`,
														duration: 60,
														subtitle: `Conversa para análise das suas habilidades, com recomendações iniciais para apoiar seu desenvolvimento na jornada do Empreenda by Fluency.`,
														dataMentor,
														vertical: mentorVertical,
														tag: dataMentor.tag,
													}}
												/>
											</div>
										)
									}

									return (
										<div className='grid grid-cols-1 gap-4 md:grid-cols-[315px_minmax(315px,_1fr)] max-w-[750px] justify-start'>
											<CardSession
												infoSession={{
													title: `Mentoria de ${mentorVertical}`,
													duration: 30,
													subtitle: `Conversa de 30 minutos sobre temas
																	relacionados a ${mentorVertical.toLowerCase()}.`,
													dataMentor,
													vertical: mentorVertical,
													isMentorshipAwari: true,
												}}
											/>
										</div>
									)
								})()}
							</div>
						</>
					)
				})()}
			</div>
		</Container>
	)
}
